import React from 'react';

import { Box } from '@mui/material';

import { tokens } from '../theme';

// Stitch eyebrow: a small pill with a dot, above a page or section heading.
export default function Eyebrow({
  children,
  tone = 'light',
}: {
  children: React.ReactNode;
  tone?: 'light' | 'navy';
}) {
  const navy = tone === 'navy';
  return (
    <Box
      component='p'
      sx={{
        m: 0,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        // secondary-fixed / on-secondary-fixed; on navy, a translucent chip with cyan text.
        bgcolor: navy ? 'rgba(76, 214, 251, 0.06)' : tokens.primaryFixed,
        color: navy ? tokens.cyan : tokens.primary,
        fontSize: '0.75rem',
        lineHeight: 16 / 12,
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
      }}
    >
      <Box
        component='span'
        aria-hidden='true'
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: navy ? tokens.cyan : tokens.secondary,
          flex: 'none',
        }}
      />
      {children}
    </Box>
  );
}
